module.exports = require('./helpers/bundle-url').getBundleURL('f1UsJ') + "logo.c51670a8.svg";